(() => {
  if (window.VaraprintApparelDiscovery) return;
  window.VaraprintApparelDiscovery = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('a[data-vp-apparel-link]');
    if (!link || link.origin !== location.origin) return;
    const url = new URL(link.href);
    const current = new URLSearchParams(location.search);
    for (const key of new Set(current.keys())) {
      if (key === 'sort_by' || key.startsWith('filter.')) {
        url.searchParams.delete(key);
        current.getAll(key).forEach(value => url.searchParams.append(key, value));
      }
    }
    url.searchParams.delete('page');
    link.href = url.href;
  }, true);
})();
